
import SnackBar from '@/components/shared/SnackBar';
export default {
    name: 'GlobalSnackBar',

    components: {
        SnackBar,
    },

    data() {
        return {
            showSnackbar: false,
        };
    },

    computed: {
        snackbarMessage() {                
            return this.$store.state.snackbar.message;
        },
    },

    watch: {
        snackbarMessage: {
            immediate: true,
            handler(newState) {
                if (newState) {
                    this.showSnackbar = true;
                }
            }
        },
        showSnackbar: {
            immediate: true,
            handler(newState) {
                if (!newState) {
                    this.$store.commit('snackbar/updateMessage', '');
                }
            }
        },
    },

    methods: {
        handleSnackbarEvent(event) {
            if (!event) {
                this.showSnackbar = false;
            }
        },
    }
}
